import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const linkStyle = css`
  color: ${p => p.theme.colors.green400};
  text-decoration: none;
`;

export const ExternalLink = styled.a`
  ${linkStyle};
`;

export const InternalLink = styled(Link)`
  color: ${p => p.theme.colors.black};

  &:hover {
    color: ${p => p.theme.colors.green400};
  }
`;
